import Radio    from '@widesk-ui/components/form/Radio';
import useTheme from '@widesk-ui/hooks/useTheme';

export type InputBooleanUncheckableProps = FieldProps & {
	initialValue?: boolean | undefined;
	value?: boolean | undefined;
}

export default function InputBooleanUncheckable(props: InputBooleanUncheckableProps) {
	const theme = useTheme();
	return (
		<Radio.Group {...props}>
			<Radio.Button style={{ background: theme.colorBgLayout }} value={undefined}>N/C</Radio.Button>
			<Radio.Button value={true}>Oui</Radio.Button>
			<Radio.Button value={false}>Non</Radio.Button>
		</Radio.Group>
	);
}
